import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 25, 50],
  totalRows: 1,
  setFilterProvince: '',
  setFilterDistrict: '',
  setFilterRegency: '',
  setFilterSite: '',
  options: [],
  optionsdevice: '',
  defaultdevice: '',
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Site', sortable: true },
    { key: 'company_name', label: 'Company' },
    { key: 'partner_name', label: 'Partner' },
    { key: 'project_name', label: 'Project' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  fieldsdashboard: [
    { key: 'id', label: 'id' },
    { key: 'name', label: 'Site Name' },
    { key: 'device_code', label: 'Device Code' },
    { key: 'value', label: 'Value' },
    { key: 'status', label: 'Status' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/sites', params }
    useIPA.get(param).then(response => {
      const site = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...site })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/site/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  setFilterProvince({ commit }, id) {
    commit('setFilterProvince', id)
  },
  setFilterDistrict({ commit }, id) {
    commit('setFilterDistrict', id)
  },
  setFilterRegency({ commit }, id) {
    commit('setFilterRegency', id)
  },
  setFilterRegencyOnly({ commit }, id) {
    commit('setFilterRegencyOnly', id)
  },
  setFilterRegencySparing({ commit }, id) {
    commit('setFilterRegencySparing', id)
  },
  setFilterSite({ commit }, id) {
    commit('setFilterSite', id)
  },
  setFilterSiteSparing({ commit }, id) {
    commit('setFilterSiteSparing', id)
  },
  getByNonFilter({ commit }) {
    const param = { status: 'internal/master/sites?province_id=&regency_id=' }
    useIPA.getGlobe(param).then(response => {
      commit('setSite', response.data.data)
    })
  },
  getByFilter({ commit }) {
    const param = { status: `internal/master/sites?province_id=${state.setFilterProvince}&regency_id=${state.setFilterProvince}` }
    useIPA.getGlobe(param).then(response => {
      commit('setSite', response.data.data)
    })
  },
  getByFilterOnly({ commit }, { province, regency }) {
    const param = { status: `internal/master/sites?province_id=${province}&regency_id=${regency}` }
    useIPA.getGlobe(param).then(response => {
      commit('setSite', response.data.data)
    })
  },
  getByFilterSparing({ commit }) {
    const param = { status: `internal/sparing/data/master/site?province_id=${state.setFilterProvince}&regency_id=${state.setFilterProvince}&district_id=${state.setFilterProvince}` }
    useIPA.getGlobe(param).then(response => {
      commit('setSite', response.data.data)
    })
  },
  getDefaultDevice({ commit }) {
    return new Promise((resolve, reject) => {
      const param = { status: 'internal/temperature/data/master/device/installed?site_id=' }
      useIPA.getGlobe(param).then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data[1])
        }
      })
    })
  },
  getDefaultDeviceSparing({ commit }) {
    return new Promise((resolve, reject) => {
      const param = { status: 'internal/master/devices/installed?site_id=' }
      useIPA.getGlobe(param).then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data[0])
        }
      })
    })
  },
  getDefaultDeviceSparingFiltered({ commit }) {
    return new Promise((resolve, reject) => {
      const param = { status: 'internal/master/devices/installed' }
      useIPA.getGlobe(param).then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          const additionals = ['pln', 'ups', 'totalizer', 'rssi', 'provider', 'alarm']
          const filteredDevices = response.data.data.filter(item => !additionals.includes(item.device_name.toLowerCase()))
          resolve(filteredDevices[0])
        }
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        project_id: formData.select_1,
        province_id: formData.province,
        regency_id: formData.regency,
        district_id: formData.district,
        code: formData.code,
        name: formData.text_1,
        description: formData.text_2,
      }
      const param = { rawData, url: 'internal/master/site', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'data-site' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/site', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, site) {
    state.items = site.rows
    state.totalRows = site.rows.length
    state.options = []
    for (let i = 0; i < site.rows.length; i++) {
      const option = []
      for (const key in site.rows[i]) {
        if (key === 'id') {
          option.value = site.rows[i][key]
        } else if (key === 'name') {
          option.title = site.rows[i][key]
        } else if (key === 'id') {
          option.oid = site.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
  setSite(state, site) {
    state.options = []
    for (let i = 0; i < site.length; i++) {
      const option = []
      for (const key in site[i]) {
        if (key === 'id') {
          option.value = site[i][key]
        } else if (key === 'name') {
          option.title = site[i][key]
        } else if (key === 'id') {
          option.oid = site[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setFilterProvince(state, id) {
    state.setFilterProvince = id
    state.options = []
    const param = { status: `internal/master/sites?province_id=${state.setFilterProvince}&regency_id=${state.setFilterRegency}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'id') {
            option.value = response.data.data[i][key]
          } else if (key === 'name') {
            option.title = response.data.data[i][key]
          } else if (key === 'id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.options.push({ ...option })
      }
    })
  },
  setFilterDistrict(state, id) {
    state.setFilterDistrict = id
    state.options = []
    const param = { status: `internal/master/sites?province_id=${state.setFilterProvince}&regency_id=${state.setFilterRegency}&district_id=${state.setFilterDistrict}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'id') {
            option.value = response.data.data[i][key]
          } else if (key === 'name') {
            option.title = response.data.data[i][key]
          } else if (key === 'id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.options.push({ ...option })
      }
    })
  },
  setFilterRegency(state, id) {
    state.setFilterRegency = id
    state.options = []
    const param = { status: `internal/master/sites?province_id=${state.setFilterProvince}&regency_id=${state.setFilterRegency}&district_id=${state.setFilterDistrict}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'id') {
            option.value = response.data.data[i][key]
          } else if (key === 'name') {
            option.title = response.data.data[i][key]
          } else if (key === 'id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.options.push({ ...option })
      }
    })
  },
  setFilterRegencyOnly(state, id) {
    console.log('id', id)
    state.setFilterRegency = id
    state.options = []
    const param = { status: `internal/master/sites?province_id=${state.setFilterProvince}&regency_id=${state.setFilterRegency ?? ''}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'id') {
            option.value = response.data.data[i][key]
          } else if (key === 'name') {
            option.title = response.data.data[i][key]
          } else if (key === 'id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.options.push({ ...option })
      }
    })
  },
  setFilterRegencySparing(state, id) {
    state.setFilterRegency = id
    state.options = []
    const param = { status: 'internal/master/locations/mylocation' }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'id') {
            option.value = response.data.data[i][key]
          } else if (key === 'name') {
            option.title = response.data.data[i][key]
          } else if (key === 'id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.options.push({ ...option })
      }
    })
  },
  setFilterSite(state, id) {
    if (id) {
      state.setFilterSite = id
    }
    state.optionsdevice = []
    const param = { status: `internal/temperature/data/master/device/installed?site_id=${state.setFilterSite}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'device_id') {
            option.value = response.data.data[i][key]
          } else if (key === 'device_name') {
            option.title = response.data.data[i][key]
          } else if (key === 'device_id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.optionsdevice.push({ ...option })
      }
    })
  },
  setFilterSiteSparing(state, id) {
    if (id) {
      state.setFilterSite = id
    }
    state.optionsdevice = []
    const param = { status: `internal/master/devices/installed?site_id=${state.setFilterSite}` }
    useIPA.getGlobe(param).then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        const option = []
        for (const key in response.data.data[i]) {
          if (key === 'device_id') {
            option.value = response.data.data[i][key]
          } else if (key === 'device_name') {
            option.title = response.data.data[i][key]
          } else if (key === 'device_id') {
            option.oid = response.data.data[i][key]
          }
        }
        state.optionsdevice.push({ ...option })
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
